import { AlertIcon, CalendarIcon, IdeasIcon, NoteIcon, OtherIcon, UsersIcon } from "@/shared/icons";

export const navLinkIcons = [
  <OtherIcon key={0} />,
  <UsersIcon key={1} />,
  <AlertIcon key={2} />,
  <NoteIcon key={3} />,
  <IdeasIcon key={4} />,
  <CalendarIcon key={5} />,
];
